import React, { useEffect } from "react";
//GraphQL
import { useMutation, gql } from "@apollo/client";
//Router
import { useParams } from "react-router-dom";

const DeliveryNoteReady = ({ setFrameTarjet }) => {
  setFrameTarjet("delivery-note-to-print");

  const { id } = useParams();

  const getMutation = () => {

    return gql`
    mutation updateOrderDeliveryNote{
      updateOrderDeliveryNote(id: ${parseInt(id)}, isDeliveryNote: true) {
          id
        }
      }
  `;
  };
  // eslint-disable-next-line
  const [executeMutation, { data, error }] = useMutation(getMutation());

  useEffect(() => {
    executeMutation();
    // eslint-disable-next-line
  }, []);
  return <></>;
};

export default DeliveryNoteReady;
